document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-card');
      
  productCards.forEach(card => {
    const swatches = card.querySelectorAll('.color-swatches .swatch');
      
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
      
        const productHandle = this.getAttribute('data-product-handle');
        const productId = this.getAttribute('data-product-id');
      
        // Remove active from other swatches in this card
        swatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');
      
        // Fetch data for this product card only
        fetchProductData(productHandle, card);
      });
    });
  });
      
  function fetchProductData(productHandle, card) {
    card.classList.add('loading');
      
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(productData => {
        updateProductCard(productData, card);
        card.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error loading product data:', error);
        card.classList.remove('loading');
      
        const errorNotification = document.createElement('div');
        errorNotification.className = 'swatch-error-notification';
        errorNotification.textContent = 'Could not load color variant. Please try again.';
        card.appendChild(errorNotification);
        setTimeout(() => errorNotification.remove(), 3000);
      });
  }
      
  function updateProductCard(productData, card) {
  // Update image
  const primaryImage = card.querySelector('.product-card__image--primary');
  if (primaryImage && productData.featured_image) {
    const newUrl = productData.featured_image.replace(/(\.\w{3,4})(\?.*)?$/, '_800x$1');
    primaryImage.src = newUrl;

    const srcsetSizes = [200,300,400,500,600,700,800,1000,1200,1400,1600,1800];
    primaryImage.srcset = srcsetSizes.map(size =>
      `${productData.featured_image.replace(/(\.\w{3,4})(\?.*)?$/, `_${size}x$1`)} ${size}w`
    ).join(', ');
  }

  const secondaryImage = card.querySelector('.product-card__image--secondary');
  if (secondaryImage && productData.images.length > 1) {
    const secondImageUrl = productData.images[1].replace(/(\.\w{3,4})(\?.*)?$/, '_800x$1');
    secondaryImage.src = secondImageUrl;
    const srcsetSizes = [200,300,400,500,600,700,800,1000,1200,1400,1600,1800];
    secondaryImage.srcset = srcsetSizes.map(size =>
      `${productData.images[1].replace(/(\.\w{3,4})(\?.*)?$/, `_${size}x$1`)} ${size}w`
    ).join(', ');
  }

  const titleElement = card.querySelector('.product-title');
  if (titleElement) {
    titleElement.textContent = productData.title;
    titleElement.href = `/products/${productData.handle}`;
  }

  const priceEls = card.querySelectorAll('.price-list sale-price, .price-list .price--highlight, .price-list .price__regular .price, .price');
  priceEls.forEach((price) => {
    if (price.closest('.price__compare, compare-at-price')) return;
    price.dataset.moneyCents = productData.price;
    if (window.DisplayCurrency) {
      window.DisplayCurrency.updateElement(price, productData.price);
    } else {
      price.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(productData.price / 100);
    }
  });

  const compareEls = card.querySelectorAll('.price-list compare-at-price, .price-list .price__compare .price, .price--compare');
  if (productData.compare_at_price && productData.compare_at_price > productData.price) {
    compareEls.forEach(el => {
      el.dataset.moneyCents = productData.compare_at_price;
      if (window.DisplayCurrency) {
        window.DisplayCurrency.updateElement(el, productData.compare_at_price);
      } else {
        el.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
        }).format(productData.compare_at_price / 100);
      }
      const container = el.closest('.price__compare, .price--compare-container');
      if (container) container.style.display = 'block';
    });
  } else {
    compareEls.forEach(el => {
      const container = el.closest('.price__compare, .price--compare-container');
      if (container) container.style.display = 'none';
    });
  }

  // Replace .variant-options
  const variantsWrapper = card.querySelector('.variant-options');
  if (variantsWrapper && productData.variants.length > 0) {
    variantsWrapper.innerHTML = '';

    productData.variants.forEach(variant => {
      const variantDiv = document.createElement('div');
      variantDiv.className = 'variant-option-wrapper';
      if (!variant.available) variantDiv.classList.add('sold-out');

      variantDiv.innerHTML = `
        <product-form>
          <form method="post" action="/cart/add">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="quantity" value="1">
            <input type="hidden" name="id" value="${variant.id}">
            <input type="hidden" name="on_success" value="force_open_drawer">
            <button type="submit" class="variant-option product-card__quick-add-button" ${!variant.available ? 'disabled' : ''}>
              ${variant.title}
            </button>
          </form>
        </product-form>
      `;
      variantsWrapper.appendChild(variantDiv);
    });
  }

  // Update URL
  const productLinks = card.querySelectorAll('a[href*="/products/"]');
  productLinks.forEach(link => {
    if (link.href.includes(window.location.hostname)) {
      link.href = `/products/${productData.handle}`;
    }
  });

  card.setAttribute('handle', productData.handle);
}

});